module.exports = __webpack_public_path__ + "static/media/theCrazyRag.dc6d78d8.m4a";